export default {
  'btrAccountsDropDown.label': 'Accounts'
};
